import Cookies from 'js-cookie'

const TokenKey = 'vue_admin_template_token'
const UserDataKey = 'userDataKey'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUserData() {
  return Cookies.get(UserDataKey) ? JSON.parse(Cookies.get(UserDataKey)) : null
}

export function setUserData(userData) {
  return Cookies.set(UserDataKey, userData)
}

export function removeUserData() {
  return Cookies.remove(UserDataKey)
}